<script setup lang="ts">
  import { useSubAppStore } from '@/store/sub-app.store'
  import { Modal, UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { onMounted, ref, watch } from 'vue'
  import FormInput from '@/components/form/FormInput.vue'
  import type { UUID } from 'node:crypto'
  import type { SubApp } from '@/types/sub-app-types'

  const search = ref<string>('')

  const subAppStore = useSubAppStore()
  const subApps = ref<SubApp[]>()
  const subAppsFiltered = ref<SubApp[]>()
  const selectedSubAppId = ref<UUID>()

  const emit = defineEmits<{
    select: [subAppId: UUID]
  }>()

  const show = defineModel<boolean>('show', { default: false })

  function selectSubApp(subAppId: UUID) {
    emit('select', subAppId)
  }

  onMounted(async () => {
    subApps.value = await subAppStore.fetchSubApps()
    subAppsFiltered.value = subApps.value
  })

  watch(search, val => {
    subAppsFiltered.value = subApps.value?.filter(subApp =>
      subApp.name.toLowerCase().includes(val.toLowerCase())
    )
  })

  watch(show, isShown => {
    if (!isShown) selectedSubAppId.value = undefined
  })
</script>

<template>
  <Modal v-model:show="show">
    <template #header>
      <h3>Duplicate flow</h3>
    </template>

    <template #default>
      <p class="warning-text">This will overwrite the flow on the destination sub app.</p>

      <FormInput v-model="search" label="Search" />

      <div class="sub-app-list">
        <UiButton
          v-for="subApp in subAppsFiltered"
          :key="subApp.id!"
          :label="subApp.name"
          :variant="subApp.id === selectedSubAppId ? 'prominent' : 'default'"
          @click="selectedSubAppId = subApp.id!"
        />
      </div>
    </template>

    <template #footer="{ close }">
      <UiButton variant="default" type="submit" label="Annuleren" @click="close" />
      <UiButton
        :disabled="!selectedSubAppId"
        variant="prominent"
        type="submit"
        label="Duplicate"
        @click="() => (selectedSubAppId ? selectSubApp(selectedSubAppId) : {})"
      />
    </template>
  </Modal>
</template>

<style lang="css" scoped>
  .warning-text {
    color: orange;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  .sub-app-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
</style>
